import { logout } from '@/api/api'
import { resetRouter } from '@/router'
const state = {
  token: "",
  user: "",
}
const getters ={
  getToken(state) {
    if (state.token) {
      return state.token
    } else {
      return window.localStorage.getItem("token")
    }
  },
  getUser(state) {
    if (state.user) {
      return state.user
    } else {
      return window.localStorage.getItem("user")
    }
  }
}
  
const mutations = {
    setToken(state,token) {
      state.token = token
      window.localStorage.setItem("token",token)
    },
    setUser(state,user) {
      state.user = user
      window.localStorage.setItem("user",user)
    }
}

const actions = {
  logout({ commit }) {
    return new Promise((resolve) => {
      logout().catch(() => {}).finally(() => {
        commit('setToken', '')
        commit('setUser', '')
        window.localStorage.removeItem("token")
        window.localStorage.removeItem("user")
        commit('menu/setMenus', [], { root: true })
        commit('menu/setRoutes', [], { root: true })
        commit('menu/setDisplayMenus', [], { root: true })
        commit('menu/setBtnMenus', [], { root: true })
        commit('menu/setActiveMenuArrary', [], { root: true })
        commit('menu/setActiveMenu', "/index", { root: true })
        commit('menu/setFlag', false, { root: true })
        resetRouter()
        resolve()
      })
    })
  }
}
  
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
  
